module.exports = "<div class=map></div>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/components/google-maps/google-map.jade
// module id = 243
// module chunks = 0